// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
export type BeneficiaryFormDetailsv2Fragment = { __typename?: 'GRATTrust', id: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, accessParameters: { __typename?: 'AccessParameterConnection', edges?: Array<{ __typename?: 'AccessParameterEdge', node?: { __typename?: 'AccessParameter', id: string, percentage?: Percent | null } | null } | null> | null }, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string, additionalContext: Array<string | null>, badgeText?: string | null, kind: Types.SummaryBeneficiaryKindv2, displayType: string, ownershipPercentage: string }, individual?: { __typename?: 'ClientProfile', id: string } | null, organization?: { __typename?: 'ClientOrganization', id: string } | null, entity?: { __typename?: 'Entity', id: string } | null }> | null };

export const Operations = {
  Fragment: {
    BeneficiaryFormDetailsv2: 'BeneficiaryFormDetailsv2' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const BeneficiaryFormDetailsv2FragmentDoc = gql`
    fragment BeneficiaryFormDetailsv2 on GRATTrust {
  id
  beneficiaries {
    id
    accessParameters {
      edges {
        node {
          id
          percentage
        }
      }
    }
    summary {
      id
      displayName
      additionalContext
      badgeText
      kind
      displayType
      ownershipPercentage
    }
    individual {
      id
    }
    organization {
      id
    }
    entity {
      id
    }
  }
}
    `;